export default __webpack_public_path__ + "static/media/pocket-brand.bc3f808c.svg";